import { render, staticRenderFns } from "./OrderServiceLead.vue?vue&type=template&id=8a47bd8c&"
import script from "./OrderServiceLead.vue?vue&type=script&lang=js&"
export * from "./OrderServiceLead.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceLead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports